<template>
    <section class="article">
        <ul class="article__list">
            <li>{{ trans('r1') }}
                <a href="mailto:info@batnorton.com" class="article__link">info@batnorton.com</a>
                {{ trans('r2') }}.
            </li>
            <li>
                {{ trans('r3') }}.
            </li>
            <li>
                {{ trans('r4') }}.
            </li>
            <li>
                {{ trans('r5') }}.
            </li>
        </ul>
    </section>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
